<template>
  <div class='select-container'>
    <label :for="name">Prompt AI</label>
    <div>
      <ul class="prompts">
        <li v-for="p in prompts" class="prompt">
          {{p.type}} : {{p.identifier}} <button @click="remove(p)">X</button>
        </li>
      </ul>
      <select v-model="type">
        <option v-for="t in types" :value="t">{{ t }}</option>
      </select>

      <treeselect
        :id="name"
        :name="name"
        :valueFormat="'object'"
        :multiple="false"
        :async="true"
        :load-options="getPrompt"
        :loadingText="'Recherche en cours ...'"
        :searchPromptText="'Ecrivez pour lancer la recherche ...'"
        :noResultsText="'Aucun résultats ...'"
        :normalizer="normalizer"
        placeholder="Selectionner le prompt AI du voice call"
        @input="add"
        ></treeselect>
      </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Modified from '/ats/modified'
import { Solr, eq, and, or } from '/solr'

export default {
  name: 'hippolyte.services.ats.filter.aiVersionSelect',
  components: {
    Treeselect, Modified
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },

    name: String
  },
  data () {
    // @todo prompts from older format
    return {
      prompts: Array.from(this.value || [], data => ({ ...data })) || [], // clone the original value
      type: 'phone_questions',
      types: []
    }
  },
  watch: {
    prompts: {
      handler (newValue) {
        this.$emit('input', newValue)
      },
      deep: true
    }
  },
  mounted () {
    this.loadTypes()
  },
  methods: {
    add (prompt) {
      // @todo avoid prompt with an already added prompt type
      this.prompts.push({ type: this.type, ...prompt })
      // this.prompt = { identifier: '' }
    },
    remove (prompt) {
      console.log('remove', prompt)
      this.prompts.splice(this.prompts.findIndex(p => p.identifier === prompt.identifier), 1)
    },
    normalizer (option) {
      // || pour la compatibilité
      return {
        id: option.id || option,
        label: option.identifier || option
      }
    },
    async loadTypes () {
      const req = new Solr({
        entity: 'AiPrompt',
        raw: true,
        limit: 0,
        facets: [{
          type: 'terms',
          name: 'type',
          field: 'type',
          mincount: 0,
          limit: 50
        }]
      })
      const { facets: { type: { buckets } } } = await this.$socket.service('entity_solr/QUERY', req.send())
      this.types = buckets.map(({ val }) => val)
    },

    async getPrompt ({ searchQuery: research, callback }) {
      const req = new Solr({
        entity: 'AiPrompt',
        raw: true,
        limit: 10,
        query: and(eq('type', this.type), `identifier:/.*${research}.*/`),
        fields: ['id', 'type', 'identifier']
      })
      const { docs } = await this.$socket.service('entity_solr/QUERY', req.send())
      callback(null, docs)
    }
  }
}
</script>
<style lang="stylus" scoped>
.prompts
  list-style-type none
  margin 0
  padding 0
  display flex
  flex-wrap wrap
  li
    border 1px #eee solid
    margin-bottom 0.4em
    button
      background #eee
      border-radius 4px
      padding 0.2em 0.5em
      cursor pointer
div.select-container
  background white
  margin 0.4em 0
  border-radius 4px
  align-items center
  label
    margin-right 1em
    text-align right
    margin-top auto
    margin-bottom auto
  select
    background #eee
    border-radius 0 4px 4px 0
    font-size 1em
    line-height 1.5em
    border 1px #eee solid
    &:focus
      border 1px #ccc solid
</style>
